import { render, staticRenderFns } from "./POIGastronomy.vue?vue&type=template&id=336af911"
import script from "./POIGastronomy.js?vue&type=script&lang=js&external"
export * from "./POIGastronomy.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports